import React from 'react';
import { TouchTargetProps } from 'apps/sigma2-ui/src/components/ui/TouchTarget';
import { TertiaryButton } from 'apps/sigma2-ui/src/components/TertiaryButton';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

type EditRubricAddCriteriaButtonProps = Pick<TouchTargetProps, 'behavior'>;

const EditRubricAddCriteriaButtonIcon: React.FC<SvgProps> = (props) => {
  const strokeColor = toSvgColor('currentColor', props);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g>
        <path
          d="M11 8L11 14"
          stroke={strokeColor}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 11H14"
          stroke={strokeColor}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.27169 13.9056L0.96875 15.0313L2.09126 10.7164M5.27169 13.9056L2.09126 10.7164M5.27169 13.9056L5.83294 13.3428M2.09126 10.7164L11.1337 1.64901C12.0068 0.773534 13.4411 0.711 14.3764 1.64901C15.2495 2.52448 15.2495 3.96273 14.3764 4.90074L13.3163 5.96383M10.8842 1.89913L14.1315 5.14639"
          stroke={strokeColor}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const EditRubricAddCriteriaButton: React.FC<
  EditRubricAddCriteriaButtonProps
> = ({ behavior }) => {
  const language = useLanguage();
  return (
    <TertiaryButton
      label={language.editRubricAddCriteriaButtonLabel()}
      icon={<EditRubricAddCriteriaButtonIcon />}
      behavior={behavior}
    />
  );
};
